/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Select, SelectProps, Size, Heading, Button, ButtonType, Icon, Flex, Tooltip, Placement } from '@vaisala-rockhopper/components';
import { VaiColor, VaiIcon } from '@vaisala-rockhopper/design-tokens';
import i18next from 'i18next';
import * as React from 'react';
import { Infobox } from '../configuration/ConfigurationFunctions';
import './ConfiguratorSelectComponent.scss';
import { useTranslation } from 'react-i18next';

interface SelectValue {
  width: Size;
  prefixCls: string;
  autoFocus: boolean;
  optionLabelProp: string;
  showArrow: boolean;
}

export interface ConfiguratorTransmitterSelectComponentProps extends SelectProps<SelectValue> {
  variant?: 'light' | 'dark';
  options?: Array<{ value: string; label: { [key: string]: string }; values?: any }>;
  heading?: string;
  disabled?: boolean;
  onConfiguratorSelectChange?(value: string, position: string): void;
  onTransmitterOptionChange?(select_key: string, selected: string): void;
  onToggleProbe?(): void;
  label?: string;
  select_key?: string;
  selected?: string;
  isActive?: boolean;
  setIsDrawerOpen: (arg0: boolean) => void;
  onDrawerDataChange: (arg0: string) => void;
  textData?: Infobox;
}

const ConfiguratorTransmitterSelectComponent = ({ ...props }: ConfiguratorTransmitterSelectComponentProps) => {
  const { t } = useTranslation();
  const [select, setSelect] = React.useState({ value: '', titleText: '' });
  const options = props.options ?? [];

  const handleChange = (selectedValue: any) => {
    if (props.onConfiguratorSelectChange) {
      if (selectedValue === '') {
        props.onConfiguratorSelectChange('remove', 'transmitter');
      } else {
        let position = props.select_key ?? 'probe1';
        props.onConfiguratorSelectChange(selectedValue, position);
      }
    } else if (props.onTransmitterOptionChange) {
      props.onTransmitterOptionChange(props.select_key ?? '', selectedValue);
    }
    setSelect((prevState) => {
      return {
        ...prevState,
        value: selectedValue,
      };
    });
  };

  const removeSecondProbe = () => {
    if (props.onToggleProbe !== undefined) {
      props.onToggleProbe();
    } else {
      console.log('no probe toggle function');
    }
    return true;
  };

  const handleDrawerOpen = (optionSelected: string) => {
    props.setIsDrawerOpen(true);
    props.onDrawerDataChange(optionSelected);
  };

  React.useEffect(() => {
    if (options.length > 0) {
      if (props.selected !== undefined && props.selected !== '') {
        if (options.some((el: any) => el.value === props.selected)) {
          setSelect((prevState) => ({
            ...prevState,
            value: props.selected !== '' && props.selected !== undefined ? props.selected : options[0].value,
          }));
        } else {
          setSelect((prevState) => ({ ...prevState, value: options[0].value }));
        }
        // setSelect(prevState => ({...prevState, value: props.selected !== "" && props.selected !== undefined  ? props.selected : options[0].value}))
      } else {
        if (props.isActive) {
          setSelect((prevState) => ({ ...prevState, value: options[0].value }));
        }
      }
      if (props.onConfiguratorSelectChange && props.select_key === 'probe2') {
        if (props.selected === undefined || props.selected === '') {
          props.onConfiguratorSelectChange(options[0].value, 'probe2');
        }
      }
      // if (props.onConfiguratorSelectChange && props.select_key !== 'probe2') {
      //   let position = props.select_key ?? 'probe1';
      //   if (props.selected !== undefined && props.selected !== '') {
      //     props.onConfiguratorSelectChange(props.selected ?? options[0].value, position);
      //   } else {
      //     if (props.isActive) {
      //       props.onConfiguratorSelectChange(options[0].value, position);
      //     }
      //   }
      // } else if (props.onTransmitterOptionChange) {
      //   if (props.selected === undefined || props.selected === '') {
      //     props.onTransmitterOptionChange(props.select_key ?? '', options[0].value);
      //   }
      // }
    }
  }, [props.options, props.selected]);

  return (
    <div className="configurator-select-component-wrapper">
      {props.select_key === 'probe2' && props.heading && (
        <Flex justifyContent={'space-between'} alignItems={'flex-end'}>
          <Heading level={3}>
            {props.heading}
            <Tooltip
              arrow={true}
              placement={Placement.BottomStart}
              triggerElement={
                <Button buttonType={ButtonType.Link} className="info-button tooltip" buttonSize={Size.M} startIcon={<Icon name={VaiIcon.HelpO} />} />
              }
            >
              {t('ui.tooltip.select_probe_2')}
            </Tooltip>
          </Heading>
          <Button
            buttonSize={Size.S}
            buttonType={ButtonType.Link}
            onClick={() => removeSecondProbe()}
            startIcon={<Icon name={VaiIcon.Minus} />}
          ></Button>
        </Flex>
      )}
      {props.heading && props.select_key !== 'probe2' && (
        <Heading level={3}>
          {props.heading}
          <Tooltip
            arrow={true}
            placement={Placement.BottomStart}
            triggerElement={
              <Button buttonType={ButtonType.Link} className="info-button tooltip" buttonSize={Size.M} startIcon={<Icon name={VaiIcon.HelpO} />} />
            }
          >
            {t('ui.tooltip.select_probe_2')}
          </Tooltip>
        </Heading>
      )}
      {/* <Select
                onChange={handleChange}
                width={props.width}
                selectDivTitle={select.titleText}
                value={select.value}
                disabled={props.disabled ?? false}
                className={`select-component select-component-${props.variant ?? 'light'} ${props.className ?? ''}`}
            >
                {options?.map((option) => {
                    return <Select.Option key={`${props.heading}-${option.value}`} value={option.value}>{(props.label ?? "") + option.label[i18next.language]}</Select.Option>
                })}
            </Select> */}
      <Button
        buttonType={ButtonType.Link}
        color={'primary'}
        endIcon={<Icon name={VaiIcon.ChevronRight} size={Size.XL} />}
        onClick={() => handleDrawerOpen('transmitter')}
      >
        {props.textData ? props.textData[i18next.language].title : select.value}
      </Button>
    </div>
  );
};

export default ConfiguratorTransmitterSelectComponent;
